<template lang='pug'>
  v-card(style="border: solid 1px;")
    v-dialog(v-model='confirmationDialog' width="500px" persistent)
      v-card(style="border: solid 1px")
        v-card-title
          | Anular venta
          v-spacer
            v-icon(aria-label="Close" @click="confirmationDialog = false")
              | mdi-close
        v-card-text.body-1.text-center
          | Esta seguro que desea anular esta venta?
        v-card-actions.text-center
          v-spacer
            v-btn(color='green darken-1', flat='', @click.native='confirmationDialog = false') No, cancelar
            v-btn(color='red darken-1', flat='', :loading="isCanceling" @click.native='cancelSale()') Si, proceder
    v-snackbar(v-model='snackbar.show' centered :color='snackbar.color' right top :timeout="5000")
      | {{snackbar.message}}
      v-btn(dark='' text='' @click='snackbar.show = false')
        | Cerrar
    v-card-title
      | Factura # {{item.reference_number}}
      v-spacer
        v-icon(aria-label="Close" @click="$emit('close')")
          | mdi-close
    v-card-subtitle(v-if="item.type !=='purchases' && item.type !== 'expenses'")
      | {{item.location_from.name}}
    v-card-text.body-1.text-center.mt-4
      v-row
        //v-data-table.elevation-1(:headers="headers" :items="desserts" :items-per-page="5")
        table.ma-auto
          thead
            tr
              th.text-xs-left Cantidad
              th.text-xs-left Referencia
              th.text-xs-left Valor/Unidad
              th.text-xs-left Valor total
          tbody
            tr(v-for='row in item.items')
              th.text-xs-left {{row.amount}}
              td.text-xs-left(style='max-width: 100px;')
                a(@click.stop="showProduct(row)") {{row.name}}
              td.text-xs-left {{row.price | numberFormat}}
              th.text-xs-left {{row.total | numberFormat}}
      v-row(v-if="item.coupon").ma-auto
        v-col
          p {{item.coupon.title}}
        v-col
          p
            b Cupón: ${{item.coupon.value}}
      v-row(v-if="item.coupon")
        p.ma-auto
          b Valor Total Final:{{item.cash}}
          //- v-flex
          //-   v-flex
          //-     |Recibido
          //-     b.ml-2 {{item.cash}}
          //-   v-flex
          //-     |Vuelto
          //-     b.ml-2 {{item.cashback}}
      v-row.justify-center(v-if="item.isCanceled")
        p.red--text() Venta anulada
      v-row.justify-center()
        v-btn.mt-6(color="info" depressed="" default="" rounded="" @click="$emit('close')")
          | Cerrar
        v-btn.mt-6(v-if="!item.isCanceled" :loading="isCanceling" color="info" depressed="" default="" rounded="" @click="openDeleteDialog")
          | Anular

</template>

<script>
  const formatter = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  })
  export default {
    name: 'BillPreview',
    filters: {
      moneyFormat: function (value) {
        return formatter.format(value)
      },
      numberFormat (val) {
        if (val) { return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
      translate: function (name) {
        switch (name) {
          case 'sales':
            return 'Venta'

          case 'purchases':
            return 'Compra'

          case 'transfers':
            return 'Traslado'

          case 'returns':
            return 'Devolucion'

          case 'store':
            return 'Tienda'

          case 'warehouse':
            return 'Bodega'
        }
      },

    },
    props: {
      item: Object,
      currentType: String,
    },
    data () {
      return {
        confirmationDialog: false,
        snackbar: {
          show: false,
          message: '',
          color: 'red',
        },
        isCanceling: false,
        headers: [
          {
            text: 'Cantidad',
            align: 'start',
            value: 'cantidad',
          },
          { text: 'Referencia', value: 'referencia' },
          { text: 'Valor/Unidad', value: 'unidad' },
          { text: 'Valor total', value: 'total' },
        ],
      }
    },
    methods: {
      openDeleteDialog () {
        const vm = this
        vm.confirmationDialog = true
      },
      showSnackbar (color, message) {
        const vm = this
        vm.snackbar.color = color
        vm.snackbar.message = message
        vm.snackbar.show = true
      },
      showSupportImage (item) {
        this.$emit('showSupportImage', item)
      },
      showProduct (item) {
        const vm = this
        vm.$store.dispatch('products/setCurrentItem', item).then(function () {
          vm.$emit('showProduct')
        })
      },
      handleStock (val, type) {
        if (type === 'stock') {
          val.trash = val.qty - val.stock
        } else {
          val.stock = val.qty - val.trash
        }
      },
      updateReturn () {
        const vm = this
        vm.$store.dispatch('transactions/updateReturn', vm.item).then(function () {
          vm.$emit('close')
        })
      },
      cancelSale () {
        const vm = this
        vm.isCanceling = true
        const data = {
          item: vm.item,
          type: 'sales',
        }
        vm.$store.dispatch('transactions/cancelItem', data).then(function () {
          vm.isCanceling = false
          vm.item.isCanceled = true
          vm.confirmationDialog = false
          vm.showSnackbar('success', 'Venta cancelada exitosamente')
        })
      },
    },

  }
</script>

<style scoped>
</style>
